import { render, staticRenderFns } from "./FormControlContentPageUse.vue?vue&type=template&id=8a8a79d8"
import script from "./FormControlContentPageUse.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlContentPageUse.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports